









import { Component, Vue } from "vue-property-decorator";
import carouselCom from "./carouselCom.vue";
import recommended from "./recommended.vue";
import mobileGames from "./mobileGames.vue";
import news from "./news.vue";
@Component({
  components: { carouselCom, recommended, mobileGames, news },
})
export default class Home extends Vue {
  public value2 = 0;
  public mounted() {
    if (this.isMobile()) {
      location.href = "https://gw.hzwlan.com/indexH5.html";
    }
  }

  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
}
